export default __webpack_public_path__ + "static/media/1(10)_tn.3f54ff80.jpg";